import GreenLogo from "../assets/logos/logo.png";
import ColoredLogo from "../assets/logos/cocharge-color.png";
import { Image } from "primereact/image";

interface CochargeLogoProps {
  green?: boolean;
  width?: string;
  height?: string;
  styles?: any;
}

const CochargeLogo: React.FC<CochargeLogoProps> = ({
  green = false,
  width = "100",
  height = "130",
  styles = {},
}) => {
  return (
    <div>
      <Image
        src={green ? GreenLogo : ColoredLogo}
        alt="cocharge"
        width={width}
        height={height}
        style={styles}
      />
    </div>
  );
};

export default CochargeLogo;
